<div class="order-item body-0">
    <div class="order-item-title h1">Your items</div>
    <div class="order-item-details">
        <div class="order-item-content">
            <div class="order-item-content-img">
                <img aria-hidden="true" imgFallback [inputSrc]="item().imageUrl" />
            </div>
            <div class="order-item-content-details">
                <div class="order-item-content-details-description">
                    <div class="order-item-content-details-title body-0">
                        {{ item().isOutOfStock ? 'Out of stock' : '' }}
                        @if (isEngravable() && engravingText()) {
                            Personalized
                        }
                        {{ item().brandName }} {{ item().name }}
                    </div>
                    <div class="order-item-content-details-qnt body-1">Quantity: {{ item().quantity }}</div>

                    <!-- Engraving display -->
                    @if (isEngravable() && hasEngraving() && engravingText()) {
                        <div class="engraving-info body-2">
                            <span class="engraving-label">Engraving:</span>
                            <span class="engraving-text">{{ engravingText() }}</span>
                        </div>
                    }

                    @if (item()?.estimatedShippingDays) {
                        <div class="order-item-content-details-shipping-availability body-2">
                            {{ item().estimatedShippingDays }}
                        </div>
                    }
                </div>
                <div class="order-item-content-prices">
                    @if (showUsd()) {
                        <div class="order-item-prices-price primary-cta">{{ item().price | currency }}</div>
                        @if (userService.canRedeemPoints()) {
                            <div class="order-item-prices-points">
                                or {{ item().amountPoints ?? itemNewPoints() | appDigitsGrouping }} {{ rewardName() }}
                            </div>
                        }
                    } @else {
                        <!-- Prices are loaded in Shopping Dollars; no US dollar amount outside checkout. -->
                        <div class="order-item-prices-price primary-cta">
                            {{ item().price | appDigitsGrouping }} {{ rewardName() }}
                        </div>
                    }
                </div>
            </div>
        </div>

        <!-- AppleCare display and Engraving modal -->
        @if (appleCareItem() || (isEngravable() && engravingText())) {
            <div class="apple-care-container">
                <app-apple-care-listing
                    [appleCareItem]="appleCareItem()"
                    [engravingText]="engravingText()"
                    [isEngravable]="isEngravable()"
                    [isOrderReview]="true"
                    [product]="item()"
                    [showUsd]="showUsd()"
                />
            </div>
        }

        @if (isDeliveredItemInReturn()) {
            <lib-notice-panel [margin]="false">{{ detailInfo }}</lib-notice-panel>
        }
        <div class="divider"></div>
        <div class="order-item-paid">
            <div class="order-item-paid-title h1">{{ paidTitle() }}</div>
            @if (showRefundInfo()) {
                <lib-notice-panel>{{ refundInfo() }}</lib-notice-panel>
            }
            <div class="order-item-paid-prices body-0">
                @if (isRefundPrices()) {
                    @if (!showUsd() || userService.canRedeemPoints()) {
                        <div>
                            <div>{{ rewardName() }} credited</div>
                            <div class="order-item-prices-price primary-cta">
                                {{ item()?.refund?.pointsCredited | appDigitsGrouping }} {{ rewardName() }}
                            </div>
                        </div>
                    }

                    <div class="order-item-paid-prices-refund">
                        <div>Refunded to card</div>
                        <div class="order-item-paid-prices-refund-details">
                            <lib-partial-hidden-credit-card
                                [cardType]="item()?.refundCard?.cardType"
                                [lastFourDigits]="item()?.refundCard?.lastFourDigits.toString() || lastFourDigits()"
                            />
                            <span class="order-item-prices-price primary-cta">
                                @if (showUsd()) {
                                    {{ item()?.refund?.totalAmountRefunded | currency }}
                                } @else {
                                    {{ item()?.refund?.totalAmountRefunded | appDigitsGrouping }} {{ rewardName() }}
                                }
                            </span>
                        </div>
                    </div>
                } @else {
                    <div>
                        <div>Subtotal</div>
                        <div class="price-line">
                            <lib-price-and-points
                                [points]="combinedSubtotalPoints()"
                                [price]="combinedSubtotalPrice()"
                                [showUsd]="showUsd()"
                            />
                        </div>
                    </div>
                    <div>
                        <div>Shipping</div>
                        <div class="shipping-free">Free</div>
                    </div>
                }
                <div class="divider bold"></div>
                <div class="order-item-paid-total">
                    <div class="primary-cta">
                        {{ totalLabel() }}
                    </div>
                    <div class="price-line">
                        @if (isRefundPrices()) {
                            <lib-price-and-points
                                [highlightTotal]="totalLabel() === 'Total amount'"
                                [points]="item()?.refund?.pointsCredited"
                                [price]="item()?.refund?.totalAmountRefunded"
                                [showUsd]="showUsd()"
                            />
                        } @else {
                            <lib-price-and-points
                                [highlightTotal]="totalLabel() === 'Total amount'"
                                [points]="combinedTotalPoints()"
                                [price]="combinedTotalPrice()"
                                [showUsd]="showUsd()"
                            />
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
